module.exports = __webpack_public_path__ + "img/panoramaThumbnail.ffffe2e6.jpg";